import { render, staticRenderFns } from "./repair-list.vue?vue&type=template&id=7a8510d2"
import script from "./repair-list.vue?vue&type=script&lang=js"
export * from "./repair-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports